import React, { Component } from "react";

import sanitizeHtml from "sanitize-html-react";
// import { timingSafeEqual } from "crypto";


class ContentTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      divStyle: {
        gridRowEnd: "span 9",
      },
      svgStyle: {
        display: "inline-block",
      },
      didReceiveStyle: false,
    };

    this.contentTileContent = React.createRef();
  }

  // Allow only a super restricted set of tags and attributes
  cleanHtml(dirty) {
    return sanitizeHtml(dirty, {
      allowedTags: ["b", "i", "em", "strong", "a", "p", "img", "h2", "h3", "li", "ul", "br"],
      allowedAttributes: {
        a: ["href", "class"],
        img: ["src", "class"],
        p: ["class"],
      },
      transformTags: {
        img: function(tagName, attribs) {
          //custom magic goes here
          if (!attribs.src.startsWith("https://wvusstatic.com1")) {
            attribsSrc = "";
          }
          return {
            tagName: "img",
            attribs: {
              src: "",
              class: "clean-image",
            },
          };
        },
      },
    });
  }

  setTileRowSpan() {
    // let tile = this.contentTileContent.current;
    document.addEventListener(
      "imageReady",
      function(e) {
        if (this.contentTileContent.current != null) {
          const rowSpan =
            Math.ceil(
              (this.contentTileContent.current.clientHeight + this.props.gridVars.rowGap) /
                this.props.gridVars.rowSpanRatio
            ) + 1;
          const divStyle = {
            gridRowEnd: "span " + rowSpan,
          };
          this.setState({ divStyle, didReceiveStyle: true });
          // }.bind(this),50)
        }
      }.bind(this)
    );
  }

  componentDidMount() {
    this.setTileRowSpan();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didReceiveStyle === false && this.props.contentProps.backgroundImage.length < 0) {
      this.fireTileSpan();
    }
  }

  fireTileSpan(eventName = "imageReady", eventData = {}) {
    if (this.state.didReceiveStyle === false) {
      const event = new CustomEvent(eventName, eventData);
      event.eventData = eventData;
      document.dispatchEvent(event);
      //this.setState({imageReady: true});
    }
  }

  renderBackgroundImage() {
    if (this.props.contentProps.backgroundImage.length > 0) {
      if (this.props.device === "mobile") {
        return (
          <img
            onLoad={(e) => {
              this.fireTileSpan("imageReady", { imageHeight: 100 });
            }}
            src={this.props.contentProps.backgroundImage}
            width="180px"
            height="100px"
          />
        );
      } else {
        return (
          <img
            onLoad={(e) => {
              this.fireTileSpan("imageReady", { imageHeight: 180 });
            }}
            src={this.props.contentProps.backgroundImage}
            width="180px"
            height="180px"
          />
        );
      }
    } else {
      return false;
      
    }
  }

  render() {
    const renderTitle = () => {
      if (this.props.contentProps.title.length > 0) {
        return <h3>{this.props.contentProps.title}</h3>;
      } else {
        return false;
      }
    };
    return (
      <div
        className={`tile content-tile ${this.props.contentProps.background} ${this.props.contentProps.tileClass}`}
        style={this.state.divStyle || undefined}
      >
        <div className={`content-tile__content`} ref={this.contentTileContent}>
          <div className={`content__inner`}>
            {renderTitle()}
            <div
              className="zeta"
              dangerouslySetInnerHTML={{ __html: this.cleanHtml(this.props.contentProps.content) }}
            />
            {this.renderBackgroundImage()}
          </div>
        </div>
      </div>
    );
  }
}

export default ContentTile;
